export default {
    data() {
        return {
            userHaveRights: true,
            userAccesstypes: {}
        };
    },

    methods: {
        cacheUserPrivileges() {
            const { id } = this.$route.query;
            const menuId = id
            // const dashBoardMenuId = location.pathname === '/' ? 1 : 0

            if (menuId) {
                const { menus } = this.$store.state;




                if (menus?.length) {
                    // const dashBoardMenu = dashBoardMenuId ? menus.find((m) => m.id == 1) : null
                    const menu = menus.find((m) => m.id == id);
                    // User AccessType
                    menu?.permissions.forEach(m => {
                        this.userAccesstypes[m.code?.split('.')[1]] = true
                    });


                    const CREATE = menu?.permissions?.find((e) => e.code.split('.')?.includes('create'));
                    const VIEW = menu?.permissions?.find((e) => e.code.split('.')?.includes('view'));
                    const UPDATE = menu?.permissions?.find((e) => e.code.split('.')?.includes('edit'));


                    switch (this.accessType) {
                        case 'CREATE':
                            this.userHaveRights = CREATE ? true : false;
                            break;
                        case 'readOnly':
                            this.userHaveRights = VIEW ? true : false;
                            break;
                        case 'update':
                            this.userHaveRights = UPDATE ? true : false;
                            break;
                        default:
                            this.accessType = 'readOnly';
                            this.userHaveRights = false;
                    }
                    this.callInitialFunctions()
                }
            }
        },
    },
};
